export default "__VITE_ASSET__Csz25zfQ__"